import React from "react";
import { BotonPrincipal } from "../componentes/btn";
import { BotonFlotante } from "../componentes/btnFlotante";
import { Contacto } from "../componentes/contacto";
import { CardServiciosInf } from "../componentes/cardsServiciosInf";
import { NavInfraestructura } from "../componentes/navInfraestructura";
import img1 from "../img/infraestructura/tecnologias/hikvision.png";
import img2 from "../img/infraestructura/tecnologias/sophia.png";
import img3 from "../img/infraestructura/tecnologias/mikrotik.png";
import img4 from "../img/infraestructura/tecnologias/mimosa.png";
import img5 from "../img/infraestructura/tecnologias/tp-link.png";
import img6 from "../img/infraestructura/tecnologias/ubiquiti.png";
import img7 from "../img/infraestructura/tecnologias/garnet.png";
import img8 from "../img/infraestructura/tecnologias/unifi.png";
import hikvision from "../img/infraestructura/integraciones/hikvision.png";
import sophia from "../img/infraestructura/integraciones/sophia.png";
import redes from "../img/infraestructura/integraciones/redes.png";
import hikvision2 from "../img/infraestructura/integraciones/hikvision.svg";
import sophia2 from "../img/infraestructura/integraciones/sophia.svg";
import fase4Cloud from "../img/infraestructura/integraciones/fase4Cloud.png";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import { Row, Col, Card } from "antd";

export const Infraestructura = () => {
  return (
    <>
      <NavInfraestructura />
      <BotonFlotante />
      {/*Header*/}
      <section
        id="header-infraestructura"
        className="animate-slide-in"
        style={{
          height: "130vh",
        }}
      >
        <Row
          gutter={[16, 16]}
          style={{
            margin: 0,
            padding: 0,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Col
            className="col-responsive"
            xs={24}
            sm={12}
            md={12}
            lg={12}
            xl={11}
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "flex-start",
              height: "100vh",
            }}
          >
            <h1 className="titulos">
              Te acompañamos en la transformación digital
            </h1>
            <div className="typewriter-container titulos">
              <h1 className="typewriter"> de tu empresa</h1>
            </div>

            <h5 className="subtitulos">
              Nos dedicamos al asesoramiento e implementación de proyectos
              integrales de seguridad, infraestructura de redes, y sensorizacion
              para la optimización de procesos.
            </h5>
            <br />
            <BotonPrincipal
              text="Más información"
              colorFondo="#ffffff"
              colorTexto="#175E6A"
              className="boton-principal-desarrollo boton-centrado"
              onClick={() => {
                const section = document.getElementById("contacto");
                section?.scrollIntoView({ behavior: "smooth" });
              }}
            />
          </Col>

          <Col
            className="col-responsive"
            xs={24}
            sm={12}
            md={12}
            lg={12}
            xl={11}
            style={{
              display: "flex",
              justifyContent: "center",
              height: "100vh",
            }}
          >
            <DotLottieReact
              src="https://lottie.host/03b66a75-8274-4a37-bf0b-7e27a806b8d1/WmhGntrroq.lottie"
              loop
              autoplay
              className="lottie-header"
              style={{
                maxWidth: "15em",
                maxHeight: "auto",
                width: "15em",
                height: "auto",
              }}
            />
          </Col>
        </Row>
      </section>

      {/*Servicios*/}
      <section
        id="serviciosInfraestructura"
        style={{
          height: "100vh",
          marginBottom: "1em",
          display: "flex",
          flexDirection: "column",
          padding: "0 20px",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <h1
          className="titulos-degrade-infraestructura"
          style={{ textAlign: "center" }}
        >
          Nuestros <b>servicios</b>
        </h1>
        <br />
        <CardServiciosInf />
        <br></br>
      </section>

      {/*Tecnologías*/}
      <section
        id="tecnologias-infraestructura"
        className="animate-slide-in"
        style={{
          height: "50vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          padding: "20px",
          width: "100%",
          overflow: "hidden",
        }}
      >
   
   <div className="scroll">
        <div>
            <img src={img1} alt="" className="img-inf"/>
            <img src={img2} alt="" className="img-inf"/>
            <img src={img3} alt="" className="img-inf"/>
            <img src={img4} alt="" className="img-inf"/>
            <img src={img5} alt="" className="img-inf"/>
            <img src={img6} alt="" className="img-inf"/>
            <img src={img7} alt="" className="img-inf"/>
            <img src={img8} alt="" className="img-inf"/>
           
        </div>

        <div>
        <img src={img1} alt="" className="img-inf"/>
            <img src={img2} alt="" className="img-inf"/>
            <img src={img3} alt="" className="img-inf"/>
            <img src={img4} alt="" className="img-inf"/>
            <img src={img5} alt="" className="img-inf"/>
            <img src={img6} alt="" className="img-inf"/>
            <img src={img7} alt="" className="img-inf"/>
            <img src={img8} alt="" className="img-inf"/>
       
        </div>
    </div>
      </section>

      {/*Integraciones*/}
      <section
        id="integraciones"
        style={{
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
          flexDirection: "column",
          marginTop: "2em",
          padding: "0 20px",
        }}
      >
        <h1
          className="titulos-degrade-infraestructura"
          style={{ textAlign: "center" }}
        >
          <b>Soluciones de integración que transforman tu negocio</b>
        </h1>
        <br></br>
        <br></br>
        <Row justify="center" gutter={[16, 16]}>
          <Col
            xs={24}
            md={12}
            style={{
              display: "flex",
              justifyContent: "center",
              textAlign: "center",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                width: "100%",
                height: "100%",
              }}
            >
              <Card
                style={{
                  position: "relative",
                  overflow: "hidden",
                  width: "100%",
                  maxWidth: "500px",
                  height: "100%",
                  boxShadow: "0 12px 12px rgba(0, 0, 0, 0.2)",
                  borderRadius: "8px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  marginBottom: "16px",
                }}
              >
                <img
                  src={sophia2}
                  alt="Sophia"
                  style={{ marginBottom: "16px", maxWidth: "100%" }}
                />

                <p className="textos-card">
                  Es más que domótica, es una experiencia única que se integra a
                  tu casa, oficina, edificio o industria para hacer tu vida más
                  simple.
                </p>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <img
                    src={sophia}
                    alt="Sophia"
                    style={{
                      width: "100%",
                      maxHeight: "160px",
                      objectFit: "contain",
                      marginTop: "16px",
                    }}
                  />
                </div>
              </Card>
            </div>
          </Col>
          <Col
            xs={24}
            md={12}
            style={{
              display: "flex",
              justifyContent: "center",
              textAlign: "center",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                width: "100%",
                height: "100%",
              }}
            >
              <Card
                style={{
                  position: "relative",
                  overflow: "hidden",
                  width: "100%",
                  maxWidth: "500px",
                  height: "100%",
                  boxShadow: "0 12px 12px rgba(0, 0, 0, 0.2)",
                  borderRadius: "8px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  marginBottom: "16px",
                }}
              >
                <h4 className="titulo-card-infraestructura">Control general</h4>
                <p className="textos-card">
                  Quienes habiten o frecuenten una casa u oficina Sophia, pueden
                  controlar absolutamente todos los aspectos del hogar a través
                  de una sola app, como por ejemplo la iluminación, cortinados,
                  cámaras de seguridad, climatización, piscina ¡Y mucho más!
                </p>
              </Card>
              <Card
                style={{
                  position: "relative",
                  overflow: "hidden",
                  width: "100%",
                  maxWidth: "500px",
                  height: "100%",
                  boxShadow: "0 12px 12px rgba(0, 0, 0, 0.2)",
                  borderRadius: "8px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  marginBottom: "16px",
                }}
              >
                <h4 className="titulo-card-infraestructura">100% Smart</h4>
                <p className="textos-card">
                  Sophia interpreta las situaciones diarias del hogar y se
                  adapta a ellas, volviendo los espacios inteligentes y
                  dinámicos. Además,{" "}
                  <b>
                    te permite controlar y monitorear toda tu casa desde donde
                    estés.{" "}
                  </b>
                </p>
              </Card>
            </div>
          </Col>
        </Row>
        <br />
        <Row justify="center" gutter={[16, 16]}>
          <Col
            xs={24}
            md={12}
            style={{
              display: "flex",
              justifyContent: "center",
              textAlign: "center",
              marginBottom: "16px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                width: "100%",
                height: "100%",
              }}
            >
              <Card
                style={{
                  position: "relative",
                  overflow: "hidden",
                  width: "100%",
                  maxWidth: "500px",
                  height: "100%",
                  boxShadow: "0 12px 12px rgba(0, 0, 0, 0.2)",
                  borderRadius: "8px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  marginBottom: "16px",
                }}
              >
                <img src={hikvision2} alt="Hikvision" />
                <h4 className="titulo-card-infraestructura">
                  Empresa líder en desarrollo de seguridad electrónica
                </h4>
                <p className="textos-card">
                  Hikvision brinda una amplia gama de productos de seguridad
                  electrónica en constante evolución tecnológica y hardware
                  reconocido por su robustez y durabilidad.
                </p>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <img
                    src={hikvision}
                    alt="Hikvision"
                    style={{
                      width: "100%",
                      maxHeight: "160px",
                      objectFit: "contain",
                      marginTop: "16px",
                    }}
                  />
                </div>
              </Card>
            </div>
          </Col>
          <Col
            xs={24}
            md={12}
            style={{
              display: "flex",
              justifyContent: "center",
              textAlign: "center",
              marginBottom: "16px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                width: "100%",
                height: "100%",
              }}
            >
              <Card
                style={{
                  position: "relative",
                  overflow: "hidden",
                  width: "100%",
                  maxWidth: "500px",
                  height: "100%",
                  boxShadow: "0 12px 12px rgba(0, 0, 0, 0.2)",
                  borderRadius: "8px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  marginBottom: "16px",
                }}
              >
                <h4 className="titulo-card-infraestructura">
                  Seguridad con tecnología de vanguardia
                </h4>
                <p className="textos-card">
                  Desde cámaras de alta definición hasta soluciones de seguridad
                  con reconocimiento de personas y vehículos, controles de
                  acceso, sensores de movimiento, alarma de incendios y mucho
                  más.
                </p>
              </Card>
              <Card
                style={{
                  position: "relative",
                  overflow: "hidden",
                  width: "100%",
                  maxWidth: "500px",
                  height: "100%",
                  boxShadow: "0 12px 12px rgba(0, 0, 0, 0.2)",
                  borderRadius: "8px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  marginBottom: "16px",
                }}
              >
                <h4 className="titulo-card-infraestructura">
                  Soluciones a medida
                </h4>
                <p className="textos-card">
                  Desarrollamos proyectos a medida de acuerdo a tu necesidad
                  poniendo a disposición nuestra experiencia, conocimiento y
                  toda la gama de productos de Hikvision.
                </p>
              </Card>
            </div>
          </Col>
        </Row>
        <Row justify="center" gutter={[16, 16]}>
          <Col
            xs={24}
            md={12}
            style={{
              display: "flex",
              justifyContent: "center",
              textAlign: "center",
              marginBottom: "16px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                width: "100%",
                height: "100%",
              }}
            >
              <Card
                style={{
                  position: "relative",
                  overflow: "hidden",
                  width: "100%",
                  maxWidth: "500px",
                  height: "100%",
                  boxShadow: "0 12px 12px rgba(0, 0, 0, 0.2)",
                  borderRadius: "8px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  marginBottom: "16px",
                }}
              >
                <h4 className="titulo-card-infraestructura">
                  Tecnología de confianza para redes más seguras y eficientes
                </h4>
                <p className="textos-card">
                  Utilizamos marcas reconocidas a nivel mundial por su robustez
                  y eficiencia en la gestión de redes para resguardar la
                  información y maximizar la productividad de tu empresa.
                </p>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <img
                    src={redes}
                    alt="Redes"
                    style={{
                      width: "100%",
                      maxHeight: "160px",
                      objectFit: "contain",
                      marginTop: "16px",
                    }}
                  />
                </div>
              </Card>
            </div>
          </Col>
          <Col
            xs={24}
            md={12}
            style={{
              display: "flex",
              justifyContent: "center",
              textAlign: "center",
              marginBottom: "16px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                width: "100%",
                height: "100%",
              }}
            >
              <Card
                style={{
                  position: "relative",
                  overflow: "hidden",
                  width: "100%",
                  maxWidth: "500px",
                  height: "100%",
                  boxShadow: "0 12px 12px rgba(0, 0, 0, 0.2)",
                  borderRadius: "8px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  marginBottom: "16px",
                }}
              >
                <h4 className="titulo-card-infraestructura">
                  Conexiones estables
                </h4>
                <p className="textos-card">
                  Realizamos cableado estructurado y redes Wi-Fi para mejorar
                  las conexiones de tu oficina o industria basándonos en la
                  seguridad, durabilidad y escalabilidad para que tus datos
                  lleguen en tiempo y seguros.
                </p>
              </Card>
              <Card
                style={{
                  position: "relative",
                  overflow: "hidden",
                  width: "100%",
                  maxWidth: "500px",
                  height: "100%",
                  boxShadow: "0 12px 12px rgba(0, 0, 0, 0.2)",
                  borderRadius: "8px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  marginBottom: "16px",
                }}
              >
                <h4 className="titulo-card-infraestructura">Optimización</h4>
                <p className="textos-card">
                  Nos dedicamos a la gestión y optimización de redes nuevas o
                  existentes con gestión avanzada de navegación y calidad de
                  servicio para que puedas aprovechar al máximo los recursos de
                  tu infraestructura impulsando la productividad de tu equipo.
                </p>
              </Card>
            </div>
          </Col>
        </Row>
      </section>

      {/*Producto*/}
      <section
        id="productosInfraestructura"
        style={{
          height: "100vh",
  
          marginBottom: "20px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "0 20px",
          overflow: "hidden",
          boxSizing: "border-box",
        }}
      >
        {" "}
        <img
          src={fase4Cloud}
          alt="Fase Cuatro Cloud"
          className="img-f4-cloud"
          style={{
            width: "80%",
            maxWidth: "200px",
            height: "auto",
          }}
        ></img>
        <h1 className="titulos-degrade-infraestructura" style={{ textAlign: "center" }}>
          Todos tus datos en un solo click
        </h1>
        <br />
      
          <h5
            className="subtitulos-principales-blancos"
            style={{
              textAlign: "center",
              maxWidth:"1200px",
            }}
          >
            Fase Cuatro CLOUD es una solución en la nube que permite a empresas
            o autónomos contar con un espacio de almacentamiento propio donde
            pueden alojar toda su información, accediéndola desde cualquier
            sitio. Además, FASE4 CLOUD agrega una serie de funcionalidad
            adicional como gestión de agenda, contactos, reuniones en línea,
            trabajo colaborativo con archivos, etc. Personalizamos tu entorno,
            configuramos los usuarios, generamos el ambiente de trabajo, te
            asesoramos y asistimos en todo el funcionamiento del espacio
            personalizado.
          </h5>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "20px",
            flexWrap: "wrap",
            marginTop: "20px",
          }}
        >
          <div
            className="blur-button"
            style={{
              animationDelay: "0s",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "auto",
              width: "300px",
            }}
          >
            <h1 className="subtitulos-cards">
              Consultá por paquetes de usuarios y espacio reservado
            </h1>
          </div>
          <div
            className="blur-button"
            style={{
              animationDelay: "0.5s",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "auto",
              width: "300px",
            }}
          >
            {" "}
            <h1 className="subtitulos-cards">
              Definimos, configuramos y ponemos en marcha tu espacio Cloud
            </h1>
          </div>
          <div
            className="blur-button"
            style={{
              animationDelay: "1s",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "auto",
              width: "300px",
            }}
          >
            {" "}
            <h1 className="subtitulos-cards">
              Brindamos asistencia y formación post-proyecto para los usuarios y
              formadores
            </h1>
          </div>
        </div>
      </section>
      
      {/*Contacto*/}
      <br></br>
      <section
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          boxSizing: "border-box",
          padding: "0 80px",
        }}
        id="contacto-footer"
        className="section-contacto-footer"
      >
        <Contacto tituloColor="#202D70" botonColor={["#5583BA", "#202D70"]} />
      </section>
    </>
  );
};

export default Infraestructura;
